const delayName = ([name, promise]: [string, any]) =>
  promise.then((result: unknown) => [name, result])

export type PromiseValues<T> = {
  [K in keyof T]: Promise<T[K]>
}

export const promiseObject = <T>(object: PromiseValues<T>): Promise<T> => {
  return Promise.all(Object.entries(object).map(delayName)).then(Object.fromEntries)
}

export const delay = (ms: number) => new Promise((res) => setTimeout(res, ms))
